(function (root, factory) {
  'use strict';
  var rules = factory();
  if (typeof module === 'object' && module.exports) module.exports = rules;
  if (root) root.TgDriverFitRules = rules;
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  var MIN_INCHES = 5;
  var MIN_CM = 12.7;
  var NUMBER = '(\\d+(?:\\.\\d+)?)';
  var UNIT = '(cm\\b|inches\\b|inch\\b|in\\b|["″”])';
  var COMPONENT = /\b(?:canopy|base|back[ -]?plate|ceiling\s+(?:plate|rose)|mounting\s+(?:plate|base)|bulb|cord|cable|chain|radius)\b/i;

  function unknown(reason) {
    return { status: 'unknown', reason: reason };
  }

  function precision(value) {
    var dot = value.indexOf('.');
    return dot < 0 ? 0 : value.length - dot - 1;
  }

  function reading(raw, rawUnit, start, end) {
    var unit = rawUnit.toLowerCase() === 'cm' ? 'cm' : 'in';
    var value = Number(raw);
    var halfStep = Math.pow(10, -precision(raw)) / 2;
    var divisor = unit === 'cm' ? 2.54 : 1;
    return {
      value: value,
      unit: unit,
      inches: value / divisor,
      min: (value - halfStep) / divisor,
      max: (value + halfStep) / divisor,
      blocked: value < (unit === 'cm' ? MIN_CM : MIN_INCHES),
      start: start,
      end: end
    };
  }

  // Accept explicit diameter labels only. This intentionally does not infer a
  // diameter from width, height, the product title, or another component.
  function classifyDiameter(text) {
    if (typeof text !== 'string' || !text.trim()) return unknown('missing_size');
    var value = text.replace(/[\u200e\u200f\u202a-\u202e\u2066-\u2069]/g, '').trim();
    if (COMPONENT.test(value)) return unknown('component_dimension');
    if (/(?:^|[^\d])-\s*\d/.test(value)) return unknown('negative_dimension');
    if (/\d(?:\.\d+)?\s*(?:[-–—/]|\bto\b)\s*\d/i.test(value)) {
      return unknown('range_or_fraction');
    }
    // Verified facts sometimes put the axis after its measurement, e.g.
    // “3.1 inches diameter × 3.3 inches high”. Do not infer an unlabeled axis.
    value = value.replace(new RegExp(NUMBER + '\\s*' + UNIT + '\\s*(high|wide|long)\\b', 'gi'), function (_, number, unit, axis) {
      return ({ high: 'H', wide: 'W', long: 'L' })[axis.toLowerCase()] + ' ' + number + unit;
    });
    if (/[x×]\s*\d/i.test(value)) return unknown('unlabelled_axis');

    var found = [];
    var prefix = new RegExp('(?:^|[^a-z0-9])(?:diameter(?=\\s*[:=]?\\s*\\d)|dia(?=\\s*[:=]?\\s*\\d)|[∅ØøΦφ⌀]|d(?=\\s*[:=]?\\s*\\d))\\s*[:=]?\\s*' + NUMBER + '\\s*' + UNIT, 'gi');
    var suffix = new RegExp('(?:^|[^a-z0-9.])' + NUMBER + '\\s*' + UNIT + '\\s*(?:diameter|dia)\\b', 'gi');
    var match;
    while ((match = prefix.exec(value))) {
      found.push(reading(match[1], match[2], match.index, prefix.lastIndex));
    }
    while ((match = suffix.exec(value))) {
      if (!found.some(function (entry) { return match.index < entry.end && suffix.lastIndex > entry.start; })) {
        found.push(reading(match[1], match[2], match.index, suffix.lastIndex));
      }
    }
    if (!found.length) return unknown('no_explicit_diameter');
    if (/(?:^|[^a-z0-9])d\s*[:=]?\s*\d/i.test(value) &&
        /\b(?:w(?:idth)?|l(?:ength)?)\s*[:=]?\s*\d/i.test(value) &&
        !/(?:diameter|dia|[∅ØøΦφ⌀])/i.test(value)) {
      return unknown('diameter_or_depth_ambiguous');
    }
    // A direct slash-separated conversion may omit the second diameter label.
    // It is accepted only in a different unit, and still checked for conflicts.
    var originals = found.slice();
    originals.forEach(function (entry) {
      var conversion = new RegExp('^\\s*/\\s*' + NUMBER + '\\s*' + UNIT, 'i').exec(value.slice(entry.end));
      if (conversion) {
        var converted = reading(conversion[1], conversion[2], entry.end, entry.end + conversion[0].length);
        if (converted.unit !== entry.unit) found.push(converted);
      }
    });
    if (found.some(function (entry) { return !Number.isFinite(entry.value) || entry.value <= 0; })) {
      return unknown('invalid_diameter');
    }

    // A second bare measurement such as “Dia 4 in / 6 in” is ambiguous.
    // Recognized H/W/L axes are allowed but never used as the diameter.
    var remainder = value.split('');
    found.forEach(function (entry) {
      for (var i = entry.start; i < entry.end; i += 1) remainder[i] = ' ';
    });
    var rest = remainder.join('').replace(new RegExp('\\b(?:h(?:eight)?|w(?:idth)?|l(?:ength)?)\\s*[:=]?\\s*' + NUMBER + '\\s*' + UNIT, 'gi'), '');
    if (new RegExp(NUMBER + '\\s*' + UNIT, 'i').test(rest)) return unknown('unlabelled_dimension');

    var unique = [];
    found.forEach(function (entry) {
      if (!unique.some(function (other) { return entry.unit === other.unit && entry.value === other.value; })) unique.push(entry);
    });
    if (unique.length > 2 || (unique.length === 2 && unique[0].unit === unique[1].unit)) {
      return unknown('multiple_diameters');
    }
    if (unique.length === 2) {
      if (unique[0].blocked !== unique[1].blocked) return unknown('threshold_conflict');
      // The intervals express each displayed value's rounding precision.
      // Both units must describe the same diameter within that precision.
      if (Math.max(unique[0].min, unique[1].min) > Math.min(unique[0].max, unique[1].max) + 1e-9) {
        return unknown('unit_conflict');
      }
    }
    var selected = unique.find(function (entry) { return entry.unit === 'in'; }) || unique[0];
    return {
      status: selected.blocked ? 'blocked' : 'threshold_met',
      diameterInches: selected.inches,
      reason: selected.blocked ? 'body_diameter_below_5_inches' : 'diameter_threshold_met_only'
    };
  }

  // rows must contain exact variant_ids and their size strings. A product-wide
  // fact may only fill a pure set/pack row when the caller explicitly opts in.
  function classifyVariant(options) {
    options = options || {};
    if (options.variantId === undefined || options.variantId === null || !Array.isArray(options.rows)) {
      return unknown('missing_variant_data');
    }
    var id = String(options.variantId);
    var matches = options.rows.filter(function (row) {
      return row && Array.isArray(row.variant_ids) && row.variant_ids.some(function (rowId) { return String(rowId) === id; });
    });
    if (!matches.length) return unknown('variant_size_not_found');
    if (matches.some(function (row) { return row.size !== matches[0].size; })) return unknown('conflicting_variant_rows');
    var result = classifyDiameter(matches[0].size);
    if (result.status !== 'unknown' || options.allowVerifiedFallback !== true ||
        typeof matches[0].size !== 'string' || !/^(?:set|pack)\s+of\s+[1-9]\d*$/i.test(matches[0].size.trim())) {
      return result;
    }
    var facts = Array.isArray(options.verifiedFacts) ? options.verifiedFacts :
      options.verifiedFacts && options.verifiedFacts.facts;
    if (!Array.isArray(facts)) return unknown('verified_fixture_diameter_missing');
    var fixtureFacts = facts.filter(function (fact) {
      return fact && typeof fact.label === 'string' && /^(?:fixture|lamp body|light body)\s+(?:size|dimensions?|diameter)$/i.test(fact.label.trim());
    });
    if (fixtureFacts.length !== 1) return unknown('verified_fixture_diameter_missing_or_ambiguous');
    var fallback = classifyDiameter(fixtureFacts[0].value);
    if (fallback.status !== 'unknown') fallback.reason = 'verified_fixture_size_for_pure_set';
    return fallback;
  }

  return { classifyDiameter: classifyDiameter, classifyVariant: classifyVariant };
});

/* Pure configuration/cart rules shared by both storefront themes. */
(function (root, factory) {
  const rules = factory();
  if (typeof module === 'object' && module.exports) Object.assign(module.exports, rules);
  if (root) root.TgUpgradeCommerce = rules;
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';
  function eligibility(data, fit, variant) {
    const source = data.lightSource;
    const excluded = !variant || variant.available === false || data.excluded === true || data.driverEnabled === false || source !== 'integrated-led';
    const options = (variant?.options || []).join(' ').toLowerCase();
    const warm = /(?:warm (?:light|white)|3000\s*k)/i.test(options) || (data.standardCct === 3000 && !/(?:cool|cold|neutral|4000|5000|6000|6500)/i.test(options));
    return {
      cct: !excluded && Boolean(data.upgrades?.cct?.id),
      brightness: !excluded && Boolean(data.upgrades?.brightness?.id) && fit.status === 'threshold_met' && warm,
      reason: excluded ? 'compatibility_unconfirmed' : fit.status === 'blocked' ? 'under_five_inches' : fit.status !== 'threshold_met' ? 'diameter_unconfirmed' : !warm ? 'warm_light_required' : 'available'
    };
  }
  function pairedItems({ variant, quantity, upgrade, kind, properties, group, title, sellingPlan }) {
    if (!variant?.id || variant.available === false || !upgrade?.id || !['brightness', 'cct'].includes(kind)) throw new Error('Select an available light and compatible upgrade.');
    if (!Number.isInteger(quantity) || quantity < 1 || quantity > 9999) throw new Error('Enter a valid light quantity.');
    if (!group || String(variant.id) === String(upgrade.id)) throw new Error('Unable to pair this configuration.');
    const label = kind === 'brightness' ? 'Brightness dimming' : 'Adjustable white color temperature';
    const fixture = { id: variant.id, quantity, properties: { ...properties, 'Lighting control': label, 'Upgrade reference': group, _tg_pair: group, _tg_role: 'fixture', _tg_upgrade_variant: String(upgrade.id) } };
    if (sellingPlan) fixture.selling_plan = sellingPlan;
    return [fixture, { id: upgrade.id, quantity, properties: { 'For light': `${title} — ${variant.title || ''}`.slice(0, 240), 'Upgrade reference': group, 'Quantity basis': 'One upgrade per light or purchased set', _tg_pair: group, _tg_role: 'upgrade', _tg_fixture_variant: String(variant.id) } }];
  }
  function reconcilePlan(cart) {
    const groups = new Map();
    for (const item of cart.items || []) {
      const p = item.properties || {};
      if (!String(p._tg_pair || '').startsWith('TG-') || !['fixture', 'upgrade'].includes(p._tg_role)) continue;
      if (!groups.has(p._tg_pair)) groups.set(p._tg_pair, []);
      groups.get(p._tg_pair).push(item);
    }
    const updates = {}, standardize = [], errors = [];
    for (const [group, lines] of groups) {
      const fixtures = lines.filter(x => x.properties._tg_role === 'fixture');
      const upgrades = lines.filter(x => x.properties._tg_role === 'upgrade');
      if (fixtures.length > 1 || upgrades.length > 1) { errors.push(group); continue; }
      if (!fixtures.length) { upgrades.forEach(x => { updates[x.key] = 0; }); continue; }
      const fixture = fixtures[0], upgrade = upgrades[0];
      if (!upgrade) {
        const properties = { ...fixture.properties };
        for (const key of ['_tg_pair', '_tg_role', '_tg_upgrade_variant', 'Upgrade reference', 'Lighting control']) delete properties[key];
        properties['Lighting control'] = 'Standard configuration';
        standardize.push({ id: fixture.key, quantity: fixture.quantity, properties });
      } else if (String(upgrade.variant_id || upgrade.id) !== String(fixture.properties._tg_upgrade_variant) || String(fixture.variant_id || fixture.id) !== String(upgrade.properties._tg_fixture_variant)) {
        errors.push(group);
      } else if (upgrade.quantity !== fixture.quantity) updates[upgrade.key] = fixture.quantity;
    }
    return { updates, standardize, errors, hasPairs: groups.size > 0 };
  }
  return { eligibility, pairedItems, reconcilePlan };
});

(() => {
  if (typeof document === 'undefined' || !window.customElements) return;
  const selections = new Map();
  const pending = new Set();
  const root = () => window.Shopify?.routes?.root || '/';
  const jsonFetch = async (path, body) => {
    const response = await fetch(root() + path, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' }, cache: 'no-store' });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || 'Your cart could not be updated.');
    return result;
  };
  function message(text, error = false) {
    let box = document.getElementById('tg-cart-configuration-status');
    if (!box) { box = document.createElement('div'); box.id = 'tg-cart-configuration-status'; box.className = 'tg-cart-configuration-status'; box.setAttribute('role', 'status'); document.body.append(box); }
    box.textContent = text; box.dataset.error = String(error);
  }
  let knownPairs = false;
  try { knownPairs = JSON.parse(document.querySelector('[data-tg-cart-pair-state]')?.textContent || '{}').hasPairs === true; } catch (_) {}
  function setKnownPairs(value) {
    knownPairs = value;
    document.documentElement.dataset.tgCartHasPairs = String(value);
  }
  setKnownPairs(knownPairs);
  let syncPromise = null, syncTimer;
  async function reconcile() {
    // An ordinary cart never acquires an extra network dependency.
    if (!knownPairs) return false;
    if (syncPromise) return syncPromise;
    syncPromise = (async () => {
      const cart = await jsonFetch('cart.js');
      const plan = window.TgUpgradeCommerce.reconcilePlan(cart);
      setKnownPairs(plan.hasPairs);
      if (plan.errors.length) throw new Error('Please contact us to verify the linked light and upgrade in your cart.');
      const changed = Object.keys(plan.updates).length > 0 || plan.standardize.length > 0;
      if (!changed) return false;
      if (Object.keys(plan.updates).length) await jsonFetch('cart/update.js', { updates: plan.updates });
      for (const item of plan.standardize) await jsonFetch('cart/change.js', item);
      const verified = window.TgUpgradeCommerce.reconcilePlan(await jsonFetch('cart.js'));
      setKnownPairs(verified.hasPairs);
      if (verified.errors.length || Object.keys(verified.updates).length || verified.standardize.length) throw new Error('Your cart changed while we matched the upgrade quantities. Please review it before checkout.');
      return true;
    })().finally(() => { syncPromise = null; });
    return syncPromise;
  }
  function synchronizeCart(event) {
    const cart = event?.detail?.cart || event?.detail?.resource;
    if (Array.isArray(cart?.items)) {
      const hasPairs = window.TgUpgradeCommerce.reconcilePlan(cart).hasPairs;
      // Add responses can contain only added rows. Only a complete cart may clear the flag.
      if (hasPairs || typeof cart.item_count === 'number') setKnownPairs(hasPairs);
    }
    if (!knownPairs) return;
    clearTimeout(syncTimer);
    syncTimer = setTimeout(async () => {
      if (pending.size || !knownPairs) return;
      try { if (await reconcile()) { sessionStorage.setItem('tg-cart-update-note', 'Your lighting-control upgrades now match the lights in your cart. Removing an upgrade keeps the standard light configuration.'); location.assign(root() + 'cart'); } }
      catch (error) { message(error.message, true); }
    }, 180);
  }
  document.addEventListener('cart:change', synchronizeCart);
  document.addEventListener('cart:update', synchronizeCart);
  if (/\/cart\/?$/.test(location.pathname)) {
    const note = sessionStorage.getItem('tg-cart-update-note');
    if (note) { sessionStorage.removeItem('tg-cart-update-note'); message(note); }
    synchronizeCart();
  }
  let checkoutPass = false, checkoutChecking = false;
  async function checkoutGuard(event, target, resume) {
    if (!knownPairs || checkoutPass) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (checkoutChecking) return;
    if (pending.size) { message('Please wait while your light and upgrade are added.'); return; }
    checkoutChecking = true; target.setAttribute('aria-busy', 'true');
    try {
      if (await reconcile()) { sessionStorage.setItem('tg-cart-update-note', 'Your upgrade quantities have been matched to your lights. Review your cart, then continue to checkout.'); location.assign(root() + 'cart'); return; }
      checkoutPass = true; resume(); checkoutPass = false;
    } catch (error) { message(error.message, true); }
    finally { checkoutPass = false; checkoutChecking = false; target.removeAttribute('aria-busy'); }
  }
  document.addEventListener('click', event => {
    if (!knownPairs || checkoutPass) return;
    const target = event.target.closest('button[name="checkout"], input[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]');
    if (!target || target.closest('tg-driver-fit')) return;
    return checkoutGuard(event, target, () => target.click());
  }, true);
  document.addEventListener('submit', event => {
    if (!knownPairs || checkoutPass) return;
    const form = event.target;
    const action = form.getAttribute?.('action') || '';
    if (!/(?:^|\/)cart(?:\?|$)/.test(action)) return;
    const submitter = event.submitter || form.querySelector('[name="checkout"]');
    if (!submitter || submitter.name !== 'checkout') return;
    return checkoutGuard(event, submitter, () => form.requestSubmit(submitter));
  }, true);

  if (customElements.get('tg-driver-fit')) return;
  class DriverFit extends HTMLElement {
    connectedCallback() {
      this.controller?.abort(); this.controller = new AbortController();
      try { this.fit = JSON.parse(this.querySelector('[data-tg-fit-data]').textContent); } catch (_) { this.fit = {}; }
      this.form = document.getElementById(this.dataset.formId);
      this.scope = document.getElementById(`shopify-section-${this.dataset.sectionId}`) || this.closest('.shopify-section') || document;
      this.select = this.querySelector('[data-tg-upgrade-choice]');
      if (!this.select) return;
      this.note = this.querySelector('[data-tg-fit-note]');
      this.status = this.querySelector('[data-tg-upgrade-status]');
      this.cacheKey = `${this.dataset.productId}:${this.dataset.formId}`;
      if (selections.has(this.cacheKey)) this.select.value = selections.get(this.cacheKey);
      this.update(this.fit.variantId);
      this.select.addEventListener('change', () => { selections.set(this.cacheKey, this.select.value); this.update(this.variant?.id); }, { signal: this.controller.signal });
      document.addEventListener('variant:change', event => {
        if (event.detail?.formId === this.dataset.formId || event.target?.id === this.dataset.formId) this.update(event.detail?.variant?.id);
      }, { signal: this.controller.signal });
      document.addEventListener('variant:update', event => {
        if (String(event.detail?.data?.productId) === this.dataset.productId && this.scope.contains(event.target)) this.update(event.detail?.resource?.id);
      }, { signal: this.controller.signal });
      const onQuantityInput = event => {
        if (event.target.matches?.('[name="quantity"]') && (event.target.form === this.form || this.form?.contains(event.target))) this.updateSummary();
      };
      this.scope.addEventListener('input', onQuantityInput, { signal: this.controller.signal });
      this.scope.addEventListener('quantity-selector:update', event => {
        if (this.form?.contains(event.target)) this.updateSummary();
      }, { signal: this.controller.signal });
      this.scope.addEventListener('change', event => {
        onQuantityInput(event);
        if (event.target.closest('variant-picker')) this.pendingVariant = true;
      }, { signal: this.controller.signal });
      // Horizon delegates on:submit at document capture. Own paired submissions earlier, at window capture.
      window.addEventListener('submit', event => this.submit(event), { capture: true, signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
    update(variantId) {
      this.pendingVariant = false;
      this.variant = (this.fit.variants || []).find(v => String(v.id) === String(variantId));
      const result = window.TgDriverFitRules.classifyVariant({ ...this.fit, variantId });
      this.dataset.fitStatus = result.status;
      this.eligible = window.TgUpgradeCommerce.eligibility(this.fit, result, this.variant);
      for (const kind of ['brightness', 'cct']) {
        const option = this.select.querySelector(`option[value="${kind}"]`);
        if (option) option.disabled = !this.eligible[kind];
      }
      if (this.select.value !== 'standard' && !this.eligible[this.select.value]) {
        this.select.value = 'standard'; selections.set(this.cacheKey, 'standard');
        this.status.textContent = 'The selected size or light color does not support that upgrade. Standard configuration is selected.';
      }
      const reasons = {
        compatibility_unconfirmed: 'Driver compatibility for this model needs confirmation. Ask us before adding an upgrade.',
        under_five_inches: 'Brightness dimming is unavailable: the light-body diameter is under 5 inches (12.7 cm), so the driver will not fit.',
        diameter_unconfirmed: 'The light-body diameter is not confirmed. Ask us to check the 5-inch minimum before choosing brightness dimming.',
        warm_light_required: 'Brightness dimming uses fixed warm-white light. Choose a documented warm-light option to see availability.',
        available: 'Brightness dimming requires a light-body diameter of at least 5 inches (12.7 cm). Existing wall dimmers or control systems need a compatibility check.'
      };
      this.note.textContent = reasons[this.eligible.reason];
      this.querySelector('[data-tg-compatibility-link]').href = `mailto:${this.fit.email}?subject=${encodeURIComponent('Lighting controls: ' + this.fit.title)}&body=${encodeURIComponent('Please confirm the lighting-control options for:\n' + location.origin + this.fit.url + '?variant=' + (variantId || '') + '\nSelected size / configuration: ' + (this.variant?.title || '') + '\nMy existing dimmer or control system: ')}`;
      this.updateSummary();
    }
    updateSummary() {
      const selected = this.select.value !== 'standard';
      this.dataset.upgradeSelected = String(selected);
      // Accelerated checkout submits a single variant; hide it only while a paired upgrade is selected.
      const stickyBars = [...(this.scope?.querySelectorAll(`sticky-add-to-cart[data-product-id="${this.dataset.productId}"]`) || [])];
      const checkoutRoots = [this.form, ...stickyBars].filter(Boolean);
      const paymentControls = [...new Set(checkoutRoots.flatMap(container => [...container.querySelectorAll('tgl-pay-now, .shopify-payment-button, shopify-accelerated-checkout, [data-shopify="payment-button"], [data-tg-direct-checkout]')]))];
      paymentControls.forEach(el => {
        if (selected) { if (!el.hasAttribute('data-tg-hidden-payment')) el.dataset.tgPreviousHidden = String(el.hidden); el.setAttribute('data-tg-hidden-payment', ''); el.hidden = true; }
        else if (el.hasAttribute('data-tg-hidden-payment')) { el.hidden = el.dataset.tgPreviousHidden === 'true'; el.removeAttribute('data-tg-hidden-payment'); }
      });
      const summary = this.querySelector('[data-tg-upgrade-summary]');
      summary.hidden = !selected;
      const quantity = Number(this.form ? new FormData(this.form).get('quantity') || 1 : 1);
      if (selected) summary.textContent = `${quantity} light(s) or purchased set(s) + ${quantity} matching upgrade(s). Use Add to cart to add both together. Upgrade price is additional and excluded from lighting discounts.`;
    }
    async submit(event) {
      if (event.target !== this.form || this.select.value === 'standard') return;
      event.preventDefault(); event.stopImmediatePropagation();
      if (pending.has(this.dataset.formId)) return;
      const selected = this.select.value;
      const data = new FormData(this.form);
      const id = data.get('id');
      const variant = (this.fit.variants || []).find(v => String(v.id) === String(id));
      const result = window.TgDriverFitRules.classifyVariant({ ...this.fit, variantId: id });
      const eligible = window.TgUpgradeCommerce.eligibility(this.fit, result, variant);
      if (this.pendingVariant || !eligible[selected]) { this.status.textContent = 'Please wait for your selected size and light color to finish updating, then check the upgrade.'; return; }
      if (!this.form.checkValidity()) { this.form.reportValidity(); return; }
      const properties = {};
      for (const [key, value] of data.entries()) { const match = /^properties\[(.+)\]$/.exec(key); if (match && typeof value === 'string') properties[match[1]] = value; }
      const group = `TG-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
      let items;
      try { items = window.TgUpgradeCommerce.pairedItems({ variant, quantity: Number(data.get('quantity') || 1), upgrade: this.fit.upgrades[selected], kind: selected, properties, group, title: this.fit.title, sellingPlan: data.get('selling_plan') }); }
      catch (error) { this.status.textContent = error.message; return; }
      pending.add(this.dataset.formId);
      const linkedButtons = this.scope?.querySelectorAll(`button[type="submit"][form="${this.dataset.formId}"], sticky-add-to-cart[data-product-id="${this.dataset.productId}"] [ref="addToCartButton"]`) || [];
      const buttons = [...new Set([...this.form.querySelectorAll('button[type="submit"]'), ...linkedButtons])];
      buttons.forEach(button => { button.disabled = true; button.setAttribute('aria-busy', 'true'); });
      this.status.textContent = 'Adding your light and matching upgrade…';
      try {
        await jsonFetch('cart/add.js', { items });
        const cart = await jsonFetch('cart.js');
        const added = (cart.items || []).filter(item => item.properties?._tg_pair === group);
        if (added.length !== 2 || added.some(item => item.quantity !== items[0].quantity)) throw new Error('Please review your cart: the complete configuration could not be confirmed.');
        setKnownPairs(true);
        location.assign(root() + 'cart');
      } catch (error) {
        // Never retry an uncertain add: it may already have reached Shopify.
        this.status.textContent = `${error.message} Check your cart before adding again.`;
        const link = document.createElement('a'); link.href = root() + 'cart'; link.textContent = ' View cart'; this.status.append(link);
      } finally {
        pending.delete(this.dataset.formId);
        buttons.forEach(button => { button.disabled = false; button.removeAttribute('aria-busy'); });
      }
    }
  }
  customElements.define('tg-driver-fit', DriverFit);
})();
